<script setup lang="ts">
import { onErrorCaptured } from 'vue';

import { tre } from '@/plugins/bugsnag';

/**
 * 此元件用意在於避免子元件在不可預期的情況下，
 * 出現了 JS 程式碼的錯誤，
 * 進而造成錯誤持續往上層傳遞，
 * 最終造成整個網站出現「白畫面」，
 * 為防止此情況發生，
 * 故籍由此元件從中攔劫錯誤持續傳遞。
 */

onErrorCaptured((e) => {
  tre(e);
  return false;
});
</script>

<template>
  <slot></slot>
</template>
